<template>
  <div>
    <div class="p-3 d-flex justify-content-between font-size-sm">
      <div>{{ $t('order') }} # {{ order.scancode }} | {{ source }}</div>
      <button
        v-if="!order.editable"
        @click="$emit('receipt', order)"
        class="btn btn-link underline-link-from-center m-0"
        data-btn="viewReceipt"
      >
        {{ $t('viewReceipt') }}
      </button>
    </div>
    <div class="d-flex justify-content-between align-items-start px-3">
      <div class="mr-3">
        <div>
          <b>{{ $t('orderPlaced') }}</b>
        </div>
        <div>{{ order.endTime | formatDateTime }}</div>
      </div>
      <div>
        <div>
          <b>{{ $t('orderTotal') }}</b>
        </div>
        <div>
          <span v-if="order.total">{{ order.total | currency }}</span>
          <span v-if="!order.total">{{ $t('notAvailableAbbr') }}</span>
        </div>
      </div>
    </div>

    <div class="px-3 py-2 my-3 bg-dark text-dark-contrast">
      <b>{{ $t('orderItems') }}</b>
    </div>
    <div class="px-3" v-if="order.lineItems && order.lineItems.length && !order.giftCards.length">
      <WCBuyItAgainSection :items="order.lineItems" :showQuantity="true" />
    </div>

    <div class="d-flex flex-wrap" v-if="order.giftCards && order.giftCards.length">
      <WCMobileOrderPanelGiftCard v-for="(gc, ind) in order.giftCards" :key="ind" :giftCard="gc" />
    </div>
  </div>
</template>

<script>
import WCBuyItAgainSection from '@/modules/user/components/WCBuyItAgainSection/WCBuyItAgainSection.vue';
import ProductImageInfoMixin from '../../../../mixins/ProductImageInfoMixin';
import WCMobileOrderPanelGiftCard from '../WCMobileOrderPanel/WCMobileOrderPanelGiftCard.vue';

export default {
  components: { WCMobileOrderPanelGiftCard, WCBuyItAgainSection },
  props: {
    order: {
      type: Object,
    },
  },
  mixins: [ProductImageInfoMixin],
  computed: {
    source() {
      return this.order.source === 'Web Cart' ? 'Online Purchase' : 'In Store Purchase';
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

.wc-item {
  flex: 0 45%;
}

.wc-item-image {
  width: rem(50px);
  height: rem(50px);
  object-fit: scale-down;
}
</style>
